import { BUSINESS_INFO } from '../lib/legal.ts';
import { LOGO_URL } from '../lib/assets.ts';

export function Footer() {
  return (
    <footer className="nf-footer-prod">
      <div className="nf-footer-prod-inner">
        <div>
          <div className="nf-logo" style={{ marginBottom: 6 }}>
            <img src={LOGO_URL} className="nf-logo-img" alt="" width={32} height={22} />
            <span>
              <span className="n">n</span>ewflix
            </span>
          </div>
          <p className="brand-blurb">
            매일 쏟아지는 새 IT 서비스,
            <br />
            OTT처럼 넘겨보며 발견하세요.
            <br />
            로그인 없이 바로 둘러볼 수 있어요.
          </p>
        </div>
        <div>
          <h4>둘러보기</h4>
          <ul>
            <li><a href="/">이번 주 톱</a></li>
            <li><a href="/">새로 등록</a></li>
            <li><a href="/">카테고리</a></li>
            <li><a href="/">편집부 픽</a></li>
          </ul>
        </div>
        {/* <div>
          <h4>등록하기</h4>
          <ul>
            <li>내 서비스 등록</li>
            <li>등록 가이드</li>
            <li>운영자 신청</li>
          </ul>
        </div> */}
        <div>
          <h4>약관</h4>
          <ul>
            <li><a href="/legal/tos">이용약관</a></li>
            <li><a href="/legal/privacy"><strong>개인정보처리방침</strong></a></li>
            <li><a href="/legal/cookies">쿠키 정책</a></li>
            <li><a href="/legal/business">사업자 정보</a></li>
            <li><a href="/contact">문의</a></li>
          </ul>
        </div>
      </div>
      <div className="nf-footer-prod-bottom">
        <div className="nf-footer-bottom-row">
          <span>
            © 2026 {BUSINESS_INFO.companyName}. 그냥 둘러보세요.
            <span> · </span>
            <a
              href="https://newflix.tistory.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="nf-footer-bottom-link"
            >
              블로그
            </a>
          </span>
          <span>Made in Seoul · v1.4.0</span>
        </div>
      </div>
    </footer>
  );
}
